import { render, staticRenderFns } from "./Coffee.vue?vue&type=template&id=e95cfbae&scoped=true"
import script from "./Coffee.vue?vue&type=script&lang=js"
export * from "./Coffee.vue?vue&type=script&lang=js"
import style0 from "./Coffee.vue?vue&type=style&index=0&id=e95cfbae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95cfbae",
  null
  
)

export default component.exports